
export default {
    mailings: [],
    mailchimpTemplates: []
}